<template>
  <div>
    <b-form-group label="Número de Níveis:">
      <b-form-spinbutton
        inline
        v-model="num_levels"
        :min="minLevels"
        max="5"
      ></b-form-spinbutton>
      <b-form-invalid-feedback v-if="levelError" :state="false" class="d-block">
        {{ levelError }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Estrutura do Plano:">
      <b-form-input
        v-for="(level, key) in levels"
        :key="key"
        v-model="levels[key]"
        :placeholder="'Nível ' + (key + 1)"
        class="mb-2"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="Ícone do Plano:">
      <b-input-group>
        <template #prepend v-if="strategic_plan.icon">
          <b-input-group-text>
            <font-awesome-icon :icon="plan_icon" />
          </b-input-group-text>
        </template>
        <b-form-input v-model="strategic_plan.icon"></b-form-input>
      </b-input-group>
    </b-form-group>
          <small class="form-text text-muted">
        <a href="https://fontawesome.com/v5/search?ic=free-collection" target="_blank" rel="noopener noreferrer">
          Ver listagem de ícones
        </a>
        — Use o nome do ícone (ex: "star") ou "fas star" para ícones sólidos.
      </small>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {},
  props: {},
  data: () => ({
    num_levels: 0,
    levels: ["Nível 1", "Nível 2", "Nível 3", "Nível 4"],
    levelError: null,
  }),
  computed: {
    ...mapState("strategic_plans", ["strategic_plan", "tree_plan_structure"]),
    plan_icon() {
      if (this.strategic_plan.icon) {
        var icon = this.strategic_plan.icon.split(" ");
        if (icon.length > 1) {
          return icon;
        } else {
          return this.strategic_plan.icon;
        }
      }
      return false;
    },
    /** Maior profundidade (0-based) presente na árvore. Ex.: 3 = existe "Nível 4". */
    maxDepthInTree() {
      const tree = this.tree_plan_structure || [];
      return this.getMaxDepthFromTree(tree, 0);
    },
    /** Mínimo de níveis permitido: 1 ou (maxDepthInTree + 1) se houver nós cadastrados. */
    minLevels() {
      const minFromTree = this.maxDepthInTree + 1;
      return Math.max(1, minFromTree);
    },
  },
  methods: {
    getMaxDepthFromTree(nodes, currentDepth) {
      if (!nodes || nodes.length === 0) return currentDepth - 1;
      let max = currentDepth;
      for (const node of nodes) {
        const childDepth = this.getMaxDepthFromTree(node.children || [], currentDepth + 1);
        max = Math.max(max, childDepth);
      }
      return max;
    },
  },
  watch: {
    num_levels: function (value) {
      this.levelError = null;
      if (value < this.levels.length) {
        const maxDepth = this.maxDepthInTree;
        if (maxDepth >= value) {
          const levelName = this.levels[value] || `Nível ${value + 1}`;
          this.levelError = `Não é possível reduzir: existe "${levelName}" cadastrado na estrutura.`;
          this.$nextTick(() => {
            this.num_levels = this.levels.length;
          });
          return;
        }
        this.strategic_plan.config.plan_structure.levels.pop();
      }

      while (value > this.levels.length) {
        this.strategic_plan.config.plan_structure.levels.push("");
      }
    },
  },
  created() {
    if (Array.isArray(this.strategic_plan.config.plan_structure.levels)) {
      this.levels = this.strategic_plan.config.plan_structure.levels;
    }
    this.num_levels = this.levels.length;
  },
};
</script>

<style>
</style>
